/**
 * Determine if there is an uploaded photo in the state context
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const noPhotoUploaded = state => Object.keys(state.data).length === 0

export default {
    noPhotoUploaded
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/image-uploader/getters.js